import { Pipe, PipeTransform } from '@angular/core';
import {ContractFrequencyEnum} from "../types/contracts.types";


@Pipe({
  name: 'contractFrequency'
})
export class ContractFrequencyEnumPipe implements PipeTransform {
  transform(value: ContractFrequencyEnum | undefined, individualText: string): string {
    if (value === null) return individualText;

    switch (value) {
      case ContractFrequencyEnum.individual:
        return individualText;
      case ContractFrequencyEnum.monthly:
        return 'monatlich';
      case ContractFrequencyEnum.annually:
        return 'jährlich';
      default:
        return individualText;
    }
  }
}
